
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";

interface CollegeData {
  id: string;
  name: string;
  college_visit_date: string | null;
  drive_start_date: string | null;
  cv_submitted_count: number;
}

interface UpcomingCollegesTableProps {
  data: CollegeData[];
  id?: string;
}

export function UpcomingCollegesTable({ data, id }: UpcomingCollegesTableProps) {
  return (
    <Card id={id}>
      <CardHeader>
        <CardTitle>Upcoming Colleges</CardTitle>
        <CardDescription>
          Colleges with upcoming visits and CV submission counts
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>College Name</TableHead>
              <TableHead>Visit Date</TableHead>
              <TableHead>Registration Start</TableHead>
              <TableHead className="text-right">CVs Submitted</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} className="text-center text-muted-foreground">
                  No upcoming colleges
                </TableCell>
              </TableRow>
            ) : (
              data.map((college) => (
                <TableRow key={college.id}>
                  <TableCell className="font-medium">{college.name}</TableCell>
                  <TableCell>
                    {college.college_visit_date ? (
                      <Badge variant="outline">
                        {format(new Date(college.college_visit_date), 'MMM dd, yyyy')}
                      </Badge>
                    ) : (
                      <span className="text-muted-foreground">Not set</span>
                    )}
                  </TableCell>
                  <TableCell>
                    {college.drive_start_date ? (
                      <Badge variant="outline">
                        {format(new Date(college.drive_start_date), 'MMM dd, yyyy')}
                      </Badge>
                    ) : (
                      <span className="text-muted-foreground">Not set</span>
                    )}
                  </TableCell>
                  <TableCell className="text-right">
                    <Badge variant="secondary">
                      {college.cv_submitted_count}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
